import { getEnvApiMode, getEnvApiUrl, getEnvApiUrls, getEnvOAuth2ClientId, getOrgIDFromEnv } from "./env";

enum ApiMode {
  PROD = "production",
  TEST = "test",
  DEV = "dev",
  ESCAET = "escaet",
  LOCAL = "local",
  IP = "ip",
  ABO = "abo",
  DRO = "dro",
}
const IP = "192.168.1.125";

export let API_MODE = getEnvApiMode() ?? ApiMode.PROD; // use .env => REACT_APP_API_MODE=local

const getUrl = () => new URL(window.location.href);

// Source: react-boilerplate => https://github.com/react-boilerplate/react-boilerplate  (app/utils/request.js)

/**
 * Build backend url
 *
 * @returns {string} Returns a url as string
 */
const buildRelativeApiBaseUrl = () => {
  const url = getUrl();
  return `${url.protocol}//api.${url.hostname}`;
};

/**
 * Get the url from env variables if exists
 *
 * @returns {string} Returns a url as string
 */
const getApiUrlFromEnvironmentVariable = (): string | undefined => {
  const url = getUrl();
  const envApiUrls = getEnvApiUrls();
  let result: string | undefined;
  Object.keys(envApiUrls).forEach((k) => {
    const hostname = k;
    if (hostname && url.hostname.match(hostname)?.length) {
      result = envApiUrls[k];
    }
  });
  return result ?? getEnvApiUrl();
};

const getApiBaseUrl = () => {
  const envApiUrl = getApiUrlFromEnvironmentVariable();
  if (envApiUrl) return envApiUrl;
  else if (API_MODE === ApiMode.LOCAL) return "http://localhost:8080";
  return buildRelativeApiBaseUrl();
}

/**
 * Get the current backend base (root) url
 *
 * @returns {string} Returns a url as string
 */
export const getHttpApiUrl = () => {
  let url = getApiBaseUrl();

  const orgId = getOrgIDFromEnv();
  if (orgId) {
    url = `${url}${url.endsWith('/') ? '' : '/'}${orgId}`;
  }

  return url;
};

export const getWebsocketApiUrl = () => {
  let url = getApiBaseUrl();

  const orgId = getOrgIDFromEnv();
  if (orgId) {
    url = `${url}?organization=${orgId}`;
  }

  const urlObj = new URL(url);

  // Adding /user
  urlObj.pathname = `${urlObj.pathname.endsWith('/') ? urlObj.pathname : `${urlObj.pathname}/`}user`;

  // Keep same security level : http -> ws & https -> wss
  urlObj.protocol = urlObj.protocol.replace("http", "ws");

  return urlObj.href;
};

export const getOAuth2ClientId = (): string | undefined => {
  if (API_MODE === ApiMode.LOCAL) return "64b03bc1a0733b00129a8e96";
  if (API_MODE === ApiMode.IP) return `64b03bc1a0733b00129a8e96`;
  if (API_MODE === ApiMode.TEST) return "64b03bc1a0733b00129a8e96";
  if (API_MODE === ApiMode.DEV) return "64b03bc1a0733b00129a8e96";
  if (API_MODE === ApiMode.ESCAET) return "64b03bc1a0733b00129a8e96";
  return getEnvOAuth2ClientId();
};
